/**
 * CefSharp Chromium bots (Outlook Safe Links and similar scanners) reject with
 * `Object Not Found Matching Id:N, MethodName:update, ParamCount:4`.
 * That is crawler traffic, not an application fault.
 */
const CEFSHARP_OBJECT_NOT_FOUND = /Object Not Found Matching Id:\d+/i;

function objectStringField(error: object, field: 'message' | 'value'): string {
  const candidate = Reflect.get(error, field);
  return typeof candidate === 'string' ? candidate : '';
}

function rejectionText(error: unknown): string {
  if (typeof error === 'string') {
    return error;
  }
  if (error instanceof Error) {
    return `${error.name} ${error.message}`;
  }
  if (error !== null && typeof error === 'object') {
    return objectStringField(error, 'message') || objectStringField(error, 'value');
  }
  return '';
}

/** True when the rejection is CefSharp / Outlook Safe Links scanner noise. */
export function isCefSharpScannerNoise(error: unknown): boolean {
  return CEFSHARP_OBJECT_NOT_FOUND.test(rejectionText(error));
}
